/* eslint-disable eqeqeq */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import _ from 'underscore';

import NotificationDirectIcon from '@atlaskit/icon/glyph/notification-direct';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { isHighDPI } from '@trello/browser';
import { renderComponent } from '@trello/component-wrapper';
import { fireConfetti, shouldFireConfetti } from '@trello/confetti';
import {
  classForDueDate,
  relativeInfoForStartDate,
  titleForDueDate,
} from '@trello/dates';
import { makePreviewCachable } from '@trello/image-previews';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { BadgesTestIds } from '@trello/test-ids';
import { UnsplashTracker } from '@trello/unsplash';

import { DASHCARDS_POWER_UP_ID } from 'app/scripts/data/dashcards-id';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { Dates } from 'app/scripts/lib/dates';
import { l } from 'app/scripts/lib/localize';
import { pluginCoverWithDefaults } from 'app/scripts/lib/plugins/plugin-cover-with-defaults';
import { isValidCover } from 'app/scripts/lib/plugins/pluginValidators';
import { Util } from 'app/scripts/lib/util';
import { Label } from 'app/scripts/models/Label';
import { serializeAttachments } from 'app/scripts/views/internal/plugins/PluginModelSerializer';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { CardFrontLabels } from 'app/src/components/CardFront/CardFrontLabels';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const t = teacupWithHelpers('badge');

// eslint-disable-next-line @trello/no-module-logic
const badgesTemplate = t.renderable(function ({
  archived,
  attachments,
  attachmentsByType,
  checkItems,
  checkItemsChecked,
  checkItemsEarliestDue,
  comments,
  description,
  due,
  dueComplete,
  location,
  notifications,
  start,
  subscribed,
  viewingMemberVoted,
  votes,
  isOnBoardTemplate,
  hideVotes,
  isCardTemplate,
  showDueCompleteCheckbox,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  if (isCardTemplate) {
    t.div(
      '.badge.is-template',
      {
        title: l('badge.template'),
        'data-testid': BadgesTestIds.TemplateBadge,
      },
      function () {
        t.span('.badge-icon.icon-sm.icon-template-card');
        return t.span('.badge-text', () => t.format('template'));
      },
    );
  }
  if (notifications) {
    t.div(
      '.badge.is-unread-notification',
      {
        title: l('badge.notifications'),
        'data-testid': BadgesTestIds.NotificationsCount,
      },
      function () {
        t.div('.badge-icon-container');
        return t.span('.badge-text', () => t.text(notifications));
      },
    );
  }
  if (subscribed) {
    t.div(
      '.badge.is-icon-only',
      {
        title: l('badge.watch'),
        'data-testid': BadgesTestIds.CardSubscribed,
      },
      () => {
        t.span('.badge-icon.icon-sm.icon-subscribe');
      },
    );
  }

  if (votes > 0 && !isCardTemplate) {
    if (!hideVotes) {
      t.div(
        '.badge',
        {
          title: l('badge.votes'),
          class: t.classify({ 'is-voted': viewingMemberVoted }),
          'data-testid': BadgesTestIds.CardVotesCount,
        },
        function () {
          t.span('.badge-icon.icon-sm.icon-vote');
          return t.span('.badge-text', () => t.text(votes));
        },
      );
    } else if (hideVotes && viewingMemberVoted) {
      t.div(
        '.badge',
        {
          title: l('badge.votes'),
          class: t.classify({ 'is-voted': viewingMemberVoted }),
          'data-testid': BadgesTestIds.CardVotesCount,
        },
        () => t.span('.badge-icon.icon-sm.icon-vote'),
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getDateBadge = (text: any) => {
    t.div(
      '.badge.js-due-date-badge',
      {
        title: titleForDueDate(due, dueComplete),
        class: t.classify({
          'mod-due-date': showDueCompleteCheckbox,
          [classForDueDate(due, dueComplete)]: true,
        }),
        'data-testid': dueComplete
          ? BadgesTestIds.DueDateBadgeCompleted
          : BadgesTestIds.DueDateBadgeNotCompleted,
      },
      function () {
        t.span('.badge-icon.icon-sm.icon-clock.badge-due-icon');

        if (showDueCompleteCheckbox) {
          t.span('.badge-icon.icon-sm.icon-checkbox-checked.badge-due-checked');
          t.span(
            '.badge-icon.icon-sm.icon-checkbox-unchecked.badge-due-unchecked',
          );
        }

        return t.span('.badge-text.js-due-date-text', () => t.text(text));
      },
    );
  };

  if (!isCardTemplate) {
    if (start && due && start <= due) {
      getDateBadge(`${Dates.toDateString(start)} - ${Dates.toDateString(due)}`);
    } else if (due) {
      getDateBadge(`${Dates.toDateString(due)}`);
    } else if (start) {
      t.div('.badge.js-start-date-badge', function () {
        t.span('.badge-icon.icon-sm.icon-clock');
        t.span('.badge-text.js-start-date-text', function () {
          t.text(
            l(relativeInfoForStartDate(start, false), {
              date: Dates.toDateString(start),
            }),
          );
        });
      });
    }
  } else {
    if (start) {
      t.div('.badge.js-start-date-badge', function () {
        t.span('.badge-icon.icon-sm.icon-clock');
        t.span('.badge-text.js-start-date-text', function () {
          t.text(Dates.toDateString(start));
        });
      });
    }

    if (due) {
      getDateBadge(Dates.toDateString(due));
    }
  }

  if (description) {
    t.div(
      '.badge.is-icon-only',
      {
        title: l('badge.description'),
        'data-testid': BadgesTestIds.DescriptionBadge,
      },
      () => t.span('.badge-icon.icon-sm.icon-description'),
    );
  }

  // Hide comments badge on templates, since we're not showing comments on card detail
  if (comments > 0 && !isOnBoardTemplate) {
    t.div(
      '.badge',
      {
        title: l('badge.comments'),
        'data-testid': BadgesTestIds.CommentsCount,
      },
      function () {
        t.span('.badge-icon.icon-sm.icon-comment');
        return t.span('.badge-text', () => t.text(comments));
      },
    );
  }

  const trelloAttachments = attachmentsByType
    ? attachmentsByType.trello.board + attachmentsByType.trello.card
    : 0;

  attachments = attachments - trelloAttachments;
  if (attachments > 0) {
    t.div(
      '.badge',
      {
        title: l('badge.attachments'),
        'data-testid': BadgesTestIds.CardAttachmentsCount,
      },
      function () {
        t.span('.badge-icon.icon-sm.icon-attachment');
        return t.span('.badge-text', () => t.text(attachments));
      },
    );
  }

  if (trelloAttachments > 0) {
    t.div(
      '.badge',
      {
        title: l('badge.trello attachments'),
        'data-testid': BadgesTestIds.TrelloAttachmentsCount,
      },
      function () {
        t.span('.badge-icon.icon-sm.icon-board');
        return t.span('.badge-text', () => t.text(trelloAttachments));
      },
    );
  }

  if (checkItems > 0) {
    t.div(
      '.badge.js-checkitems-badge',
      {
        title: l('badge.checkitems'),
        class: t.classify({
          'is-complete': checkItemsChecked === checkItems,
          [classForDueDate(checkItemsEarliestDue, false)]:
            checkItemsEarliestDue != null,
        }),
      },
      function () {
        t.span('.badge-icon.icon-sm.icon-checklist');
        return t.span('.badge-text.js-checkitems-badge-text', function () {
          t.text(checkItemsChecked);
          t.text('/');
          t.text(checkItems);
          if (checkItemsEarliestDue) {
            t.text(' • ');
            return t.text(Dates.toDateString(checkItemsEarliestDue));
          }
        });
      },
    );
  }

  if (archived) {
    t.div(
      '.badge',
      {
        title: l('badge.archived.title'),
        'data-testid': BadgesTestIds.ArchivedBadge,
      },
      function () {
        t.span('.badge-icon.icon-sm.icon-archive');
        return t.span('.badge-text', () => t.text(l('badge.archived.text')));
      },
    );
  }

  if (location) {
    return t.div(
      '.badge',
      {
        title: l('badge.location'),
        'data-testid': BadgesTestIds.LocationBadge,
      },
      () => t.span('.badge-icon.icon-sm.icon-location'),
    );
  }
});

// This whole file shouldn't exist. It only exists because the *previous*
// way that the QuickCardEditor was implemented was even worse. But I'm not
// going to fight that fight today. This is me taking the easy way out.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearCover = function (this: any) {
  this.$el.removeClass('is-covered');
  $('.js-card-stickers', this.$el).css('height', '');
  $('.js-card-cover', this.$el)
    .css({
      'background-origin': '',
      'background-image': '',
      'background-color': '',
      height: '',
      padding: '',
    })
    .removeClass('is-no-preview-size color-card-cover');
  return this.clearColorCover();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearColorCover = function (this: any) {
  return $('.js-card-cover', this.$el).removeClass((index, className) =>
    (
      className.match(/\b(color-card-cover|color-blind-pattern)-\S+/g) || []
    ).join(' '),
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderCover = function (this: any) {
  let calculatedHeight;
  const board = this.model.getBoard();
  // Assume board is nullable since it can't be retrieved sometimes
  if ((board && !board.getPref('cardCovers')) || this.onCalendar) {
    // card covers are disabled on the board or user is on calendar
    this.clearCover();
    this.clearFullCover();
    return this;
  }

  if (!this.model.hasCover()) {
    // card doesn't (or no longer) has a native cover
    this.renderPluginCover();
    return this;
  }

  const {
    idAttachment,
    idUploadedBackground,
    color,
    scaled,
    edgeColor,
    sharedSourceUrl,
    size,
    idPlugin,
  } = this.model.get('cover');

  const $cardCover = $('.js-card-cover', this.$el);

  const $cardStickers = $('.js-card-stickers', this.$el);

  this.clearColorCover();

  if (size === 'full' && this.shouldRenderFullCover()) {
    return this.renderFullCover();
  } else {
    this.clearFullCover();
  }

  const shouldRenderPluginCover = idPlugin && board?.isPluginEnabled(idPlugin);

  if (color) {
    calculatedHeight = this.model.hasStickers() ? 64 : 32;
    $cardCover
      .css({
        'background-color': '',
        'background-image': '',
        'background-size': '',
        height: calculatedHeight,
      })
      .toggleClass('is-no-preview-size', false);
    $cardCover.addClass(
      `color-card-cover color-card-cover-${color} color-blind-pattern-${color}`,
    );
    $cardStickers.css('height', calculatedHeight);
  } else if (idAttachment || idUploadedBackground || shouldRenderPluginCover) {
    let left;
    const minWidth = isHighDPI() ? 600 : 300;
    let preview =
      (left = Util.smallestPreviewBiggerThan(scaled, minWidth)) != null
        ? left
        : Util.biggestPreview(scaled);

    // Not sure how this can happen but supporting it anyway just in case it's a legacy thing.
    if (preview == null && idAttachment && this.model.attachmentList != null) {
      const attachmentCover = this.model.attachmentList.get(
        this.model.get('idAttachmentCover'),
      );
      if (attachmentCover == null) {
        return null;
      }
      // @ts-expect-error TS(2739): Type '{ url: any; }' is missing the following prop... Remove this comment to see the full error message
      preview = { url: attachmentCover.get('url') };
    }

    $cardCover
      .css({
        'background-color': edgeColor != null ? edgeColor : 'transparent',
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        'background-image': `url("${makePreviewCachable(preview.url)}")`,
      })
      .toggleClass('is-no-preview-size', preview == null);

    if (preview != null) {
      const maxHeight = Math.min(preview.height, 260); // An arbitrarily chosen number

      // 245 is the effective width of the card (including padding and margin
      // and scrollbars)
      calculatedHeight = (preview.height * 245) / preview.width;
      if (calculatedHeight <= maxHeight) {
        $cardCover.css({
          height: calculatedHeight,
          'background-size': 'cover',
        });
        $cardStickers.css('height', calculatedHeight);
      } else {
        $cardCover.css({
          height: maxHeight,
          'background-size': 'contain',
        });
        $cardStickers.css('height', maxHeight);
      }

      if (idUploadedBackground) {
        UnsplashTracker.trackOncePerInterval(sharedSourceUrl);
      }
    }
  }

  this.$el.addClass('is-covered');

  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearFullCover = function (this: any) {
  $('.js-card-stickers', this.$el).css('height', '');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  this.$el.removeClass(function (index: any, className: any) {
    // matches "color-card-cover" and "color-card-cover-<colorName>"
    const classesToRemove =
      className.match(/\b(color-card-cover|color-blind-pattern)\S*/g) || [];
    classesToRemove.push('full-cover-list-card');
    classesToRemove.push('full-cover-list-card-dark');
    classesToRemove.push('dashcard');

    return classesToRemove.join(' ');
  });

  return this.$el.css({
    'background-size': '',
    'background-image': '',
    'background-position': '',
    'background-repeat': '',
    'background-color': '',
    'min-height': '',
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderFullCover = function (this: any) {
  this.clearCover();
  this.clearFullCover();

  const { color, scaled, edgeColor, brightness, idPlugin } =
    this.model.get('cover');

  if (idPlugin && !this.model.getBoard().isPluginEnabled(idPlugin)) {
    return this;
  }

  if (idPlugin === DASHCARDS_POWER_UP_ID) {
    this.$el.addClass('dashcard');
  }

  this.$el.addClass('full-cover-list-card');

  if (brightness === 'dark') {
    this.$el.addClass('full-cover-list-card-dark');
  }

  if (color) {
    this.$el.addClass(
      `color-card-cover color-card-cover-${color} color-blind-pattern-${color}`,
    );
  } else {
    let cardHeight, left;
    const minWidth = isHighDPI() ? 600 : 300;
    const preview =
      (left = Util.smallestPreviewBiggerThan(scaled, minWidth)) != null
        ? left
        : Util.biggestPreview(scaled);

    const styles = {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      'background-image': `url("${preview.url}")`,
      'background-size': 'cover',
    };

    // @ts-expect-error TS(2531): Object is possibly 'null'.
    const maxHeight = Math.min(preview.height, 260);

    if (this.$el.height() > maxHeight) {
      cardHeight = 'auto';
      styles['background-size'] = 'contain';
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      styles['background-position'] = 'center';
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      styles['background-repeat'] = 'no-repeat';
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      styles['background-color'] = edgeColor;
    } else {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      const calculatedHeight = (preview.height * 245) / preview.width;

      if (calculatedHeight <= maxHeight) {
        cardHeight = calculatedHeight;
      } else {
        cardHeight = maxHeight;
      }
    }

    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    styles['min-height'] = cardHeight;

    this.$el.css(styles);

    $('.js-card-stickers', this.$el).css('height', this.$el.height());
  }

  this.$el.addClass('is-covered');

  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFullCoverStylesForInitialRender = function (this: any) {
  let left;
  const { idAttachment, scaled } = this.model.get('cover');

  const minWidth = isHighDPI() ? 600 : 300;
  let preview =
    (left = Util.smallestPreviewBiggerThan(scaled, minWidth)) != null
      ? left
      : Util.biggestPreview(scaled);

  // Not sure how this can happen but supporting it anyway just in case it's a legacy thing.
  if (preview == null && idAttachment && this.model.attachmentList != null) {
    const attachmentCover = this.model.attachmentList.get(
      this.model.get('idAttachmentCover'),
    );
    if (attachmentCover == null) {
      return null;
    }
    // @ts-expect-error TS(2739): Type '{ url: any; }' is missing the following prop... Remove this comment to see the full error message
    preview = { url: attachmentCover.get('url') };
  }

  if (preview == null) {
    return null;
  }

  const styles = {
    'background-image': `url("${preview.url}")`,
    'background-size': 'cover',
  };

  const maxHeight = Math.min(preview.height, 260);

  const calculatedHeight = (preview.height * 245) / preview.width;

  if (calculatedHeight <= maxHeight) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    styles['min-height'] = `${calculatedHeight}px`;
  } else {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    styles['min-height'] = `${maxHeight}px`;
  }

  return t.stylify(styles);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderPluginCover = function (this: any) {
  return this.waitForId(this.model, () => {
    return pluginRunner
      .one({
        command: 'card-cover',
        board: this.model.getBoard(),
        card: this.model,
        list: this.model.getList(),
        timeout: 10000,
        options: {
          attachments: serializeAttachments(this.model.attachmentList.models, [
            'id',
            'url',
          ]),
          cardDetail: false,
        },
        // normally we wouldn't specify the plugins as the command is enough
        // because we split the card-cover capability into an old version & new
        // we need to only hit the old style ones here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        fxPluginFilter(plugin: any) {
          return !(plugin.get('tags') || []).includes('plugin-cover-beta');
        },
      })
      .then((pluginCover) => {
        // to avoid race conditions since this was async, check if there is
        // a native cover again
        if (this.model.hasCover()) {
          return;
        }
        // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
        if (!isValidCover(pluginCover)) {
          throw new Error('Invalid cover supplied');
        }
        const sanitizedCover = pluginCoverWithDefaults(pluginCover);
        // update the CSS

        const $cardCover = $('.js-card-cover', this.$el);
        $cardCover
          .css({
            'background-origin': 'content-box',
            'background-color': sanitizedCover.edgeColor,
            'background-image': `url("${sanitizedCover.url}")`,
            'background-position': sanitizedCover.position,
            'background-repeat': 'no-repeat',
            'background-size': sanitizedCover.size,
            height: `${sanitizedCover.height}px`,
            padding: sanitizedCover.padding,
          })
          .removeClass('is-no-preview-size');
        $('.js-card-stickers', this.$el).css(
          'height',
          sanitizedCover.stickerHeight,
        );
        return this.$el.addClass('is-covered');
      })
      .catch(() => {
        // to avoid race conditions since this was async, check if there is
        // a native cover again
        if (!this.model.hasCover()) {
          this.clearCover();
          return this.clearFullCover();
        }
      });
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getBadgesHtml = function (this: any) {
  let left;
  const badges = (left = this.model.get('badges')) != null ? left : {};

  return badgesTemplate({
    subscribed: badges.subscribed,
    description: badges.description,
    comments: badges.comments,
    attachments: badges.attachments,
    attachmentsByType: badges.attachmentsByType,
    checkItems: badges.checkItems,
    checkItemsChecked: badges.checkItemsChecked,
    checkItemsEarliestDue: badges.checkItemsEarliestDue,
    hideVotes: !!this.model.getBoard()?.get('prefs')?.hideVotes,
    votes: badges.votes,
    viewingMemberVoted: badges.viewingMemberVoted,
    due: this.model.get('due'),
    dueComplete: this.model.get('dueComplete'),
    notifications: _.filter(ModelCache.all('Notification'), (notification) => {
      return (
        notification.get('unread') &&
        this.model.id != null &&
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        notification.get('data')?.card?.id === this.model.id
      );
    }).length,
    archived: this.model.get('closed'),
    location: badges.location && this.model.getBoard()?.isMapPowerUpEnabled(),
    isOnBoardTemplate: this.model.isOnBoardTemplate(),
    isCardTemplate: !!this.model.get('isTemplate'),
    showDueCompleteCheckbox: this.model.editable(),
    start: this.model.get('start'),
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderBadges = function (this: any) {
  $('.js-badges', this.$el).html(this.getBadgesHtml());
  const notificationIconDiv = this.$('.badge-icon-container')[0];
  if (notificationIconDiv) {
    this.unmountNotificationIcon = renderComponent(
      <NotificationDirectIcon label="" size="small" />,
      notificationIconDiv,
    );
  }

  const subscribeIcon = this.$('.icon-subscribe-container')[0];
  if (subscribeIcon) {
    this.unmountSubscribedIcon = renderComponent(
      <NotificationDirectIcon label="" size="small" />,
      subscribeIcon,
    );
  }
  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeSubscribedIconBadge = function (this: any) {
  this.unmountSubscribedIcon?.();
  this.unmountSubscribedIcon = null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeNotificationIconBadge = function (this: any) {
  this.unmountNotificationIcon?.();
  this.unmountNotificationIcon = null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateDateBadges = function (this: any) {
  this.updateDueDate();
  return this.updateCheckItemsEarliestDue();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateDueDate = function (this: any) {
  const due = this.model.get('due');
  const start = this.model.get('start');
  const dueComplete = this.model.get('dueComplete');

  const badgeElem = this.el.querySelector('.js-due-date-badge');
  const badgeText = this.el.querySelector('.js-due-date-text');

  if (badgeElem && badgeText) {
    const currentTitle = badgeElem.getAttribute('title');
    const newTitle = titleForDueDate(due, dueComplete);

    // If no update is necessary, return early
    if (currentTitle === newTitle) {
      return this;
    }

    badgeElem.setAttribute('title', newTitle);
    const oldClass = badgeElem.classList.value.split(' ').pop();
    badgeElem.classList.replace(oldClass, classForDueDate(due, dueComplete));
    if (start && start < due) {
      badgeText.innerText = `${Dates.toDateString(
        start,
      )} - ${Dates.toDateString(due)}`;
    } else {
      badgeText.innerText = Dates.toDateString(due);
    }
  }
  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateCheckItemsEarliestDue = function (this: any) {
  const badges = this.model.get('badges');

  if (!badges) {
    return this;
  }

  const { checkItemsEarliestDue } = badges;

  const $badgeElem = $('.js-checkitems-badge', this.$el);

  if ($badgeElem) {
    $badgeElem.removeClass((index, className) =>
      (className.match(/\bis-due-\S+/g) || []).join(' '),
    );

    if (checkItemsEarliestDue) {
      $badgeElem.addClass(classForDueDate(checkItemsEarliestDue, false));
    }
  }

  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toggleDueDateComplete = function (this: any, e: any) {
  if (!this.model.editable()) {
    return;
  }

  stopPropagationAndPreventDefault(e);

  const newValue = !this.model.get('dueComplete');

  const traceId = Analytics.startTask({
    taskName: 'edit-card/dueComplete',
    source: 'cardView',
  });

  if (
    newValue &&
    (shouldFireConfetti(this.model.get('name')) ||
      shouldFireConfetti(this.model.getList().get('name')))
  ) {
    fireConfetti({
      x: e.pageX / window.innerWidth,
      y: e.pageY / window.innerHeight,
    });
  }

  return this.model.update(
    {
      dueComplete: newValue,
      traceId,
    },
    tracingCallback(
      {
        taskName: 'edit-card/dueComplete',
        traceId,
        source: 'cardView',
      },
      (err, card) => {
        if (card) {
          Analytics.sendUpdatedCardFieldEvent({
            field: 'dueComplete',
            source: 'cardView',
            attributes: {
              taskId: traceId,
            },
            containers: {
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              card: { id: card.id },
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              list: { id: card.idList },
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              board: { id: card.idBoard },
            },
          });
        }
      },
    ),
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateBadges = function (this: any) {
  const previousBadges = this.model.previous('badges');
  const currentBadges = this.model.get('badges');
  if (previousBadges && currentBadges) {
    const changedBadges = Object.keys(previousBadges).filter(
      (key) => !_.isEqual(currentBadges[key], previousBadges[key]),
    );

    if (changedBadges.length === 1 && changedBadges.includes('dueComplete')) {
      return this.renderDueComplete();
    }
  }

  return this.renderBadges();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderMembers = function (this: any, e: any) {
  // Called whenever members removed or added but not on initial board render
  const memberHtmls = (() => {
    const result = [];
    for (let i = this.model.memberList.models.length - 1; i >= 0; i--) {
      const member = this.model.memberList.models[i];
      result.push(this.getMemberOnCardHtml(member));
    }
    return result;
  })();
  $('.js-list-card-members', this.$el).empty().append(memberHtmls.join(''));
  this.defer(() => {
    DragSort.refreshDraggableCardMembers();
  });
  return this;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const labelsData = function (this: any) {
  return (
    _.chain(this.model.getLabels())
      // @ts-expect-error TS(2345): Argument of type '(a: Label, b: Label) => number' ... Remove this comment to see the full error message
      .sort(Label.compare)
      .map((label) => this.model.dataForLabel(label))
      .filter((uiLabel) => !_.isEmpty(uiLabel.color))
      .value()
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderLabels = function (this: any) {
  const container = this.el.querySelector(
    '.js-list-card-front-labels-container',
  );
  // Check for the existence of an existing React root in case this is called
  // multiple times, which is possible.
  if (!container.querySelector('.js-react-root')) {
    renderComponent(<CardFrontLabels idCard={this.model.id} />, container);
  }
  return this;
};
